function LegalLayout({ title, updated, children }) {
	return (
		<div className="pt-24">
			<section className="py-14 md:py-20">
				<div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
					<h1 className="font-heading text-4xl font-extrabold text-slate-900 dark:text-white">{title}</h1>
					<p className="mt-2 text-sm text-slate-500 dark:text-slate-400">Last updated: {updated}</p>
					<div className="mt-8 space-y-6 text-slate-600 dark:text-slate-300 leading-relaxed">{children}</div>
				</div>
			</section>
		</div>
	);
}

function Block({ h, children }) {
	return (
		<div>
			<h2 className="font-heading text-xl font-bold text-slate-900 dark:text-white mb-2">{h}</h2>
			<p>{children}</p>
		</div>
	);
}

export function PrivacyPolicy() {
	return (
		<LegalLayout title="Privacy Policy" updated="June 2026">
			<p>SchoolXpert360 ("we", "us") respects your privacy. This policy explains how we collect, use and protect the information you share when you submit an enquiry or consultation request on our website.</p>
			<Block h="Information we collect">We collect the details you voluntarily provide through our forms — such as your name, phone number, email, school name, city, and requirement — along with basic technical data like referring source and UTM campaign parameters used for marketing analysis.</Block>
			<Block h="How we use your information">We use your information solely to respond to your enquiry, provide consultation, and share relevant school-growth services. With your consent, we may contact you by phone, email, or messaging platforms regarding your enquiry.</Block>
			<Block h="Marketing consent">We only contact you for marketing purposes when you have explicitly agreed via the consent checkbox on our forms. You may withdraw consent at any time by contacting us.</Block>
			<Block h="Data storage & security">Your data is stored securely on our servers and synchronised to our internal lead-management systems. We never expose your data publicly and never sell it to third parties.</Block>
			<Block h="Your rights">You can request access to, correction of, or deletion of your personal data by emailing grow@schoolxpert360.com.</Block>
		</LegalLayout>
	);
}

export function Terms() {
	return (
		<LegalLayout title="Terms & Conditions" updated="June 2026">
			<p>By using the SchoolXpert360 website and submitting an enquiry, you agree to the following terms.</p>
			<Block h="Use of the website">This website provides information about our school-growth consultancy services. Content is for general information and does not constitute a binding offer unless confirmed in a signed engagement.</Block>
			<Block h="Assurance disclaimers">Claims such as "100% Admission Assurance*" and "50 Admissions Assured for Preschool Launch*" are subject to eligibility criteria, market conditions, and the specific scope of engagement, which are discussed and documented during your consultation.</Block>
			<Block h="Enquiries">Submitting a form does not create a client relationship. A relationship is formed only upon a mutually signed agreement.</Block>
			<Block h="Limitation of liability">SchoolXpert360 is not liable for indirect or consequential losses arising from use of the website or information provided herein.</Block>
			<Block h="Contact">For any questions about these terms, email grow@schoolxpert360.com.</Block>
		</LegalLayout>
	);
}
